module.exports = __webpack_public_path__ + "media/images/elionline/icons/da_svolgere_allenamento_facilitato-09b461f2f75f2ccaca0d8a83aad6dcea.svg";